var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.208,
    height: 22.989,
    viewBox: "0 0 21.208 22.989",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(-1193.792 -328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    transform: "translate(1199 328)",
    fill: "none",
    stroke: "#9fafca",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M1208.54,5578.4l-6.2,7.762",
    transform: "translate(-6.44 -5237.284)",
    fill: "none",
    stroke: "#9fafca",
    strokeLinecap: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.88aee5f1a6800bc8a51f4623f8248063.svg";
export { ForwardRef as ReactComponent };